module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "content-chapter1",
    attrs: {
      "id": "calibre_toc_4"
    }
  }, [_c('a', {
    attrs: {
      "id": "b3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_002#a3"
    }
  }, [_vm._v("CHAPTER ONE")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapter-title"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_002#a3"
    }
  }, [_c('span', [_vm._v("What ClutterBug are You?")])]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("While on my journey from "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("Cluttered to Clean")]), _vm._v(", I realized that "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("not all organizing systems work for all people.")]), _vm._v(" I would watch organizing shows on HGTV and copy the beautifully stacked, matching bin systems in my own closet, only to have it look like a bomb went off a week later. I remember asking myself all the time, why can’t I get my home together? "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The reason I was struggling was because my brain doesn’t work like those organizers I see on TV. I have a natural tendency to organize things a certain way and not every system or product is made to work with my style. I also discovered that most of my clients organized differently as well; some of them like to see all of their belongings out all of the time. They would claim “out of sight, out of mind,” which was the exact opposite of how I organized. Some clients were meticulous pilers, perfectionists even. They would “wait” to put away their belongings until they had the time to do it “right.” "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', [_vm._v("The most important thing I have learned during my journey towards living a cleaner and clutter-free lifestyle is that having an organized home isn’t about having a beautiful or Pinterest-worthy space. An organized home doesn’t necessarily mean a perfect home, and it certainly doesn’t include spending a lot of money or endless amounts of time to make it look like a magazine spread. Being truly organized is about making things so functional and easy to use that you are able to save time, save money, and enjoy a household that practically runs itself. Sometimes, the most efficient way to organize your space isn’t necessarily what works the best for someone else’s home. ")]), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("Organizing is not one size fits all.")]), _c('span'), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Once I finally realized that copying beautiful organizing systems from Pinterest, television, or magazines wasn’t going to actually keep me organized, I started finding solutions that worked for my unique organizing style, my unique space, and my very unique family. "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("After countless attempts to organize the hundreds of toys played with everyday in my home daycare, it occurred to me that perhaps the reason the toys were never staying organized had less to do with the fact that children are walking disaster zones and more to do with the fact that I had not given them an organizing system that was easy and effective for them to use all by themselves. "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', [_vm._v("I had purchased dozens of different plastic storage containers in all shapes and sizes, and I even packed away all of the messiest toy offenders, like the dreaded feet impaling Lego. Despite all of my best efforts, the mess remained. Every night I would spend an hour picking up all of the toys, and just a few hours into the next morning, the playroom would be a heap of brightly colored toys once again. ")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The only toys the children seemed able to really pick up and put away properly all by themselves were the ones that they could literally throw and toss back into the container, without much effort. "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_11"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33dd1f9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/RealLifeOrg_split_011.vue
// module id = 90
// module chunks = 0